import RepositoryContainer from '@src/components/repository/RepositoryContainer';
import React from 'react';
import { WithRouterProps } from 'react-router';

const RepositoryPage = (props: WithRouterProps) => {
  return <RepositoryContainer entity={props.params.entity} entityId={props.params.entityId} />;
};

export default RepositoryPage;
